import React from "react";

/* King of Spades — real artwork on the front, matte black + gold spade on the back.
   Two 3D faces so the back shows whenever the card flips during the fall. */
export default function KingCard() {
  return (
    <>
      <div className="card-face card-face-front" data-testid="king-card">
        <img src="/king-of-spades.webp" alt="King of Spades" draggable="false" />
      </div>
      <div className="card-face card-face-back" aria-hidden>
        <span className="card-back-frame">
          <span className="card-back-spade">♠</span>
        </span>
      </div>
    </>
  );
}
